import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const retryInteracPayment = transactionId =>
  call(websocketFetch, 'retry_interac_payment', {
    transaction_id: transactionId,
  });
